export const ExportMultiForms = {
  "title": "Export multiple forms to a sheet",
  "addFiles": "Add files",
  "Export": "Export",
  "Cancel": "Cancel",
  "note": "Please note that forms should be based on the same form.",
  "option1": "Contain forms you closed recently",
  "option2": "Append to an existing file"
}